/* Optional theme-only recommendations. No Boost, cookies, localStorage or cart mutations. */
(function (global) {
  'use strict';
  if (global.TLTRecommendations) {
    if (typeof module !== 'undefined' && module.exports) module.exports = global.TLTRecommendations;
    return;
  }
  var DATA_SECTION = 'tlt-recommendation-data';
  var scopeIndex = 0;
  var privacyLoads = new WeakSet();

  function validId(value) { return /^\d+$/.test(String(value || '')); }
  function validHandle(value) { return typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,179}$/.test(value); }
  function historyKey(themeId) {
    if (!validId(themeId)) throw new Error('Missing theme context.');
    return 'tlt:recent:v1:' + themeId;
  }
  function permission(host) {
    var api = host.Shopify && host.Shopify.customerPrivacy;
    if (!api || typeof api.preferencesProcessingAllowed !== 'function') return null;
    try { var allowed = api.preferencesProcessingAllowed(); return typeof allowed === 'boolean' ? allowed : null; }
    catch (_) { return null; }
  }
  function ensurePrivacy(host) {
    if (permission(host) !== null || !host.Shopify || typeof host.Shopify.loadFeatures !== 'function' || privacyLoads.has(host)) return;
    privacyLoads.add(host);
    try {
      // Official Shopify permission reader only. Never call setTrackingConsent or alter a banner.
      host.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error && host.document) host.document.dispatchEvent(new host.CustomEvent('tlt:privacy-ready'));
      });
    } catch (_) { /* Unknown permission remains fail-closed for this page. */ }
  }
  function cleanHistory(value) {
    var seenIds = new Set(), seenHandles = new Set();
    return (Array.isArray(value) ? value : []).filter(function (row) {
      if (!row || !validId(row.id) || !validHandle(row.handle) || seenIds.has(String(row.id)) || seenHandles.has(row.handle)) return false;
      seenIds.add(String(row.id)); seenHandles.add(row.handle); return true;
    }).slice(0, 24).map(function (row) { return { id: String(row.id), handle: row.handle }; });
  }
  function storageFor(host) { try { return host.sessionStorage; } catch (_) { return null; } }
  function readHistory(storage, themeId, allowed) {
    try {
      var key = historyKey(themeId);
      if (allowed !== true) { if (allowed === false && storage) storage.removeItem(key); return []; }
      return storage ? cleanHistory(JSON.parse(storage.getItem(key) || '[]')) : [];
    } catch (_) { return []; }
  }
  function remember(storage, themeId, product, allowed) {
    var rows = readHistory(storage, themeId, allowed);
    if (allowed !== true || !storage || !product || !validId(product.id) || !validHandle(product.handle)) return false;
    var next = cleanHistory([product].concat(rows));
    try {
      if (JSON.stringify(rows) === JSON.stringify(next)) return false;
      storage.setItem(historyKey(themeId), JSON.stringify(next)); return true;
    } catch (_) { return false; }
  }
  function ids(value) { return String(value || '').split(',').filter(validId); }
  function requestUrl(route, context, params) {
    var current = new URL(context.currentUrl);
    var url = new URL(route, current);
    if (url.origin !== current.origin) throw new Error('Recommendations must use the current storefront.');
    url.search = ''; url.hash = '';
    url.searchParams.set('section_id', DATA_SECTION);
    Object.keys(params || {}).forEach(function (key) { url.searchParams.set(key, String(params[key])); });
    if (context.themeRole !== 'main') {
      if (!validId(context.themeId)) throw new Error('Missing preview context.');
      url.searchParams.set('preview_theme_id', String(context.themeId));
    }
    ['_fd', 'pb'].forEach(function (key) { if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key)); });
    return url;
  }
  function productRoute(root, handle) {
    if (!validHandle(handle)) throw new Error('Invalid product handle.');
    return String(root || '/').replace(/\/?$/, '/') + 'products/' + handle;
  }
  function validateResponse(wrapper, expected) {
    if (!wrapper || wrapper.dataset.themeId !== String(expected.themeId) || wrapper.dataset.kind !== expected.kind) {
      throw new Error('Recommendation context changed.');
    }
    if (expected.handle && (wrapper.dataset.productHandle !== expected.handle || wrapper.dataset.productId !== String(expected.id))) {
      throw new Error('Product identity changed.');
    }
    return wrapper;
  }
  async function fetchResponse(url, expected, signal, host) {
    host = host || global;
    var controller = new host.AbortController();
    var abort = function () { controller.abort(); };
    if (signal) { if (signal.aborted) abort(); else signal.addEventListener('abort', abort, { once: true }); }
    var timer = host.setTimeout(abort, 15000);
    try {
      var request = new URL(url);
      var response = await host.fetch(request.href, { signal: controller.signal, credentials: 'same-origin' });
      if (response.url && new URL(response.url).origin !== request.origin) throw new Error('Unexpected recommendation origin.');
      // Shopify may activate a theme preview with a same-origin redirect. Restore the section
      // request once after activation, and still require the returned theme's exact identity.
      if (response.redirected && request.searchParams.has('preview_theme_id')) {
        request.searchParams.delete('preview_theme_id');
        response = await host.fetch(request.href, { signal: controller.signal, credentials: 'same-origin' });
        if (response.url && new URL(response.url).origin !== request.origin) throw new Error('Unexpected recommendation origin.');
      }
      if (!response.ok) throw new Error('Recommendations unavailable.');
      var html = await response.text();
      if (controller.signal.aborted) throw new Error('Recommendations cancelled.');
      var document = new host.DOMParser().parseFromString(html, 'text/html');
      return validateResponse(document.querySelector('[data-tlt-recommendation-response]'), expected);
    } finally {
      host.clearTimeout(timer);
      if (signal) signal.removeEventListener('abort', abort);
    }
  }
  function selectCards(cards, excluded, limit) {
    var seen = new Set((excluded || []).map(String));
    return cards.filter(function (card) {
      var id = card && card.dataset && card.dataset.productId;
      if (!validId(id) || seen.has(id)) return false;
      seen.add(id); return true;
    }).slice(0, limit);
  }
  function preserveLinks(scope, context) {
    Array.prototype.forEach.call(scope.querySelectorAll('a[href]'), function (link) {
      var current = new URL(context.currentUrl), url = new URL(link.getAttribute('href'), current);
      if (url.origin !== current.origin) { link.removeAttribute('href'); return; }
      if (context.themeRole !== 'main') url.searchParams.set('preview_theme_id', String(context.themeId));
      ['_fd', 'pb'].forEach(function (key) { if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key)); });
      link.href = url.href; // Preserve the API's existing pr_* tracking parameters.
    });
  }
  function syncCurrency(scope, host, baseCurrency) {
    var api = host.DoublyGlobalCurrency;
    var picker = host.document && host.document.querySelector('[name="doubly-currencies"]');
    var current = api && api.currentCurrency || picker && picker.value || baseCurrency;
    if (!/^[A-Z]{3}$/.test(current || '')) return false;
    var money = Array.prototype.slice.call(scope.querySelectorAll('span.money'));
    if (!money.length) return false;
    var pending = money.some(function (span) { return span.getAttribute('doubly-currency') !== current; });
    if (pending && api && typeof api.convertAll === 'function') {
      try { api.convertAll(current, '#' + scope.id + ' span.money'); } catch (_) { return false; }
      return money.every(function (span) { return span.getAttribute('doubly-currency') === current; });
    }
    // Fresh server markup explicitly contains the base currency code. Do not show stale
    // converted amounts if the app disappeared after a currency switch.
    return !pending || current === baseCurrency && money.every(function (span) { return !span.getAttribute('doubly-currency'); });
  }
  async function mapBounded(rows, worker, signal) {
    var output = new Array(rows.length), next = 0;
    await Promise.all(Array.from({ length: Math.min(3, rows.length) }, async function () {
      while (next < rows.length && !signal.aborted) {
        var index = next++;
        try { output[index] = await worker(rows[index]); } catch (_) { output[index] = null; }
      }
    }));
    return output.filter(Boolean);
  }
  var api = { historyKey: historyKey, cleanHistory: cleanHistory, permission: permission, ensurePrivacy: ensurePrivacy, readHistory: readHistory,
    remember: remember, requestUrl: requestUrl, productRoute: productRoute, validateResponse: validateResponse,
    fetchResponse: fetchResponse, selectCards: selectCards, preserveLinks: preserveLinks, syncCurrency: syncCurrency, mapBounded: mapBounded };
  global.TLTRecommendations = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.customElements || !global.HTMLElement) return;

  class RecentHistory extends global.HTMLElement {
    connectedCallback() {
      this.reconcile = () => {
        ensurePrivacy(global);
        var allowed = permission(global), storage = storageFor(global);
        var changed = remember(storage, this.dataset.themeId, { id: this.dataset.productId, handle: this.dataset.productHandle }, allowed);
        if (changed || this.previousPermission !== allowed) global.document.dispatchEvent(new global.CustomEvent('tlt:recent-history'));
        this.previousPermission = allowed;
      };
      this.reconcile();
      global.document.addEventListener('visitorConsentCollected', this.reconcile);
      global.document.addEventListener('tlt:privacy-ready', this.reconcile);
      // Covers delayed Shopify API readiness while permission remains fail-closed.
      this.timer = global.setInterval(this.reconcile, 1000);
    }
    disconnectedCallback() {
      global.document.removeEventListener('visitorConsentCollected', this.reconcile);
      global.document.removeEventListener('tlt:privacy-ready', this.reconcile);
      global.clearInterval(this.timer);
    }
  }
  class Recommendations extends global.HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.shell = this.querySelector('[data-tlt-recommendation-shell]');
      this.grid = this.querySelector('[data-tlt-recommendation-grid]');
      if (!this.shell || !this.grid) return;
      this.id = 'tlt-recommendations-scope-' + (++scopeIndex);
      this.context = { currentUrl: global.location.href, themeId: this.dataset.themeId, themeRole: this.dataset.themeRole };
      this.limit = Math.max(1, Math.min(this.dataset.mode === 'recent' ? 12 : 10, Number(this.dataset.limit) || 4));
      this.cartIds = ids(this.dataset.cartIds);
      this.seedId = this.dataset.seedId;
      this.revision = 0;
      this.onCart = () => {
        this.cancel(); this.grid.replaceChildren(); this.shell.hidden = true;
        global.clearTimeout(this.refreshTimer);
        this.refreshTimer = global.setTimeout(() => this.refresh(true), 200);
      };
      this.onHistory = () => { if (this.dataset.mode === 'recent') this.refresh(false); };
      this.onPrivacy = () => {
        if (this.dataset.mode !== 'recent') return;
        var allowed = permission(global);
        if (allowed !== true) { readHistory(storageFor(global), this.dataset.themeId, allowed); this.cancel(); this.grid.replaceChildren(); this.shell.hidden = true; }
        else this.refresh(false);
      };
      global.document.addEventListener('on:cart:change', this.onCart);
      global.document.addEventListener('on:cart:after-merge', this.onCart);
      global.document.addEventListener('tlt:recent-history', this.onHistory);
      global.document.addEventListener('visitorConsentCollected', this.onPrivacy);
      global.document.addEventListener('tlt:privacy-ready', this.onPrivacy);
      this.lastPermission = permission(global);
      this.currencyTimer = global.setInterval(() => {
        if (this.dataset.mode === 'recent') {
          ensurePrivacy(global);
          var allowed = permission(global);
          if (allowed !== this.lastPermission) { this.lastPermission = allowed; this.onPrivacy(); }
          if (allowed !== true) return;
        }
        if (this.grid.children.length) this.shell.hidden = !syncCurrency(this, global, this.dataset.baseCurrency || 'GBP');
      }, 1000);
      if (this.dataset.mode === 'recent') ensurePrivacy(global);
      this.refresh(false);
    }
    cancel() { this.revision++; if (this.controller) this.controller.abort(); }
    async refresh(updateCart) {
      this.cancel();
      var revision = this.revision;
      this.controller = new global.AbortController();
      var signal = this.controller.signal;
      this.grid.replaceChildren(); this.shell.hidden = true;
      try {
        if (updateCart) {
          var cart = await fetchResponse(requestUrl(this.dataset.cartUrl || '/cart', this.context),
            { themeId: this.context.themeId, kind: 'cart' }, signal);
          this.cartIds = ids(cart.dataset.cartIds); this.seedId = cart.dataset.seedId;
        }
        var cards = [];
        if (this.dataset.mode === 'recent') {
          var history = readHistory(storageFor(global), this.context.themeId, permission(global));
          var excluded = this.cartIds.concat([this.dataset.currentProductId]);
          var rows = history.filter(function (row) { return excluded.indexOf(row.id) === -1; }).slice(0, this.limit);
          var wrappers = await mapBounded(rows, row => fetchResponse(
            requestUrl(productRoute(this.dataset.root, row.handle), this.context),
            { themeId: this.context.themeId, kind: 'product', handle: row.handle, id: row.id }, signal), signal);
          wrappers.forEach(function (wrapper) { cards = cards.concat(Array.prototype.slice.call(wrapper.querySelectorAll('[data-tlt-card]'))); });
        } else if (validId(this.seedId)) {
          var related = await fetchResponse(requestUrl(this.dataset.recommendationUrl || '/recommendations/products', this.context,
            { product_id: this.seedId, limit: 10, intent: 'related' }), { themeId: this.context.themeId, kind: 'related' }, signal);
          cards = Array.prototype.slice.call(related.querySelectorAll('[data-tlt-card]'));
        }
        if (signal.aborted || this.revision !== revision || !this.isConnected) return;
        if (this.dataset.mode === 'recent' && permission(global) !== true) { this.onPrivacy(); return; }
        cards = selectCards(cards, this.cartIds.concat([this.dataset.currentProductId, this.seedId]), this.limit);
        this.grid.replaceChildren();
        cards.forEach(card => this.grid.appendChild(global.document.importNode(card, true)));
        preserveLinks(this.grid, this.context);
        this.shell.hidden = !cards.length || !syncCurrency(this, global, this.dataset.baseCurrency || 'GBP');
      } catch (_) {
        if (this.revision === revision) { this.grid.replaceChildren(); this.shell.hidden = true; }
      }
    }
    disconnectedCallback() {
      this.cancel(); this.started = false;
      global.clearTimeout(this.refreshTimer); global.clearInterval(this.currencyTimer);
      global.document.removeEventListener('on:cart:change', this.onCart);
      global.document.removeEventListener('on:cart:after-merge', this.onCart);
      global.document.removeEventListener('tlt:recent-history', this.onHistory);
      global.document.removeEventListener('visitorConsentCollected', this.onPrivacy);
      global.document.removeEventListener('tlt:privacy-ready', this.onPrivacy);
    }
  }
  global.customElements.define('tlt-recent-history', RecentHistory);
  global.customElements.define('tlt-recommendations', Recommendations);
})(typeof window !== 'undefined' ? window : globalThis);
